
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/storagecontainerprices/privacy-policy",
      function () {
        return require("private-next-pages/storagecontainerprices/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/storagecontainerprices/privacy-policy"])
      });
    }
  